import React, { useState, useEffect } from "react";
import "./VideoFrameOne.css";

import TTGvideo1 from "../../assets/ttgvideo1.mov";
import TTGvideo2 from "../../assets/ttgvideo2.mov";
import TTGvideo3 from "../../assets/ttgvideo3.mov";
import TTGvideo4 from "../../assets/ttgvideo4.mov";
import TTGvideo5 from "../../assets/ttgvideo5.mov";
import TTGvideo6 from "../../assets/ttgvideo6.mov";
import TTGvideo7 from "../../assets/ttgvideo7.mov";
 
const VideoFrame = () => {
  const [currentVideo, setCurrentVideo] = useState(1);
  const [isFading, setIsFading] = useState(false);

  const videos = [
    TTGvideo1,
    TTGvideo2,
    TTGvideo3,
    TTGvideo4,
    TTGvideo5,
    TTGvideo6,
    TTGvideo7
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setIsFading(true);
      setTimeout(() => {
        setCurrentVideo(prevVideo => {
          const nextVideo = prevVideo === videos.length ? 1 : prevVideo + 1;
          setIsFading(false);
          return nextVideo;
        });
      }, 1000); // Delay the video change until after the fade-out transition
    }, 5000); // Change video every 5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="video-frame-container">
      <video
        autoPlay
        muted
        loop
        className={`video-frame ${isFading ? "fade-out" : ""}`}
        src={videos[currentVideo - 1]}
      />
    </div>
  );
};

export default VideoFrame;
